import {
  initMapForDossier,
  loadFeatureForMap,
} from '../common/carte/carte-util.js';

import { Panel } from './listing-panel.js';
import { Carto } from '../common/carte/carte-config.js';

export class CartoPanel extends Panel {
  constructor(previewContainer, mapContainerSelector, onElementSelected) {
    super();

    this.previewContainer = previewContainer;
    this.mapContainerSelector = mapContainerSelector;
    this.onElementSelected = onElementSelected;
  }

  init(dossierId) {
    const mapContainer = document.querySelector(this.mapContainerSelector);
    mapContainer.style.height = `${this.previewContainer.offsetHeight}px`;
    mapContainer.innerHTML = '';

    this.initGeoref();
    const empriseInitiale = Carto.dossierGeoref
      ? [
          Carto.dossierGeoref.minX,
          Carto.dossierGeoref.minY,
          Carto.dossierGeoref.maxX,
          Carto.dossierGeoref.maxY,
        ]
      : null;

    this.map = initMapForDossier(
      'carte',
      {
        controls: {
          extentRecentrerVue: empriseInitiale,
        },
      },
      {
        maxZoom: window.Carto.config.options.encartMaxZoom ?? 20,
      },
    );

    if (Carto.dossierGeoref) {
      this.map.getView().fit(empriseInitiale);
      loadFeatureForMap(
        this.map,
        [
          'Operation',
          'Collectif',
          'AireEtude',
          'Thematique',
          'Mobilier',
          'OeuvreObjet',
          'OeuvreArchitecture',
        ],
        [dossierId],
      ).then((features) => {
        if (features.length) {
          document.querySelector('#masque-no-georef').style.display = 'none';
        } else {
          document.querySelector('#masque-no-georef').style.display = 'flex';
        }
      });
    } else {
      document.querySelector('#masque-no-georef').style.display = 'flex';
    }
  }

  setElement(element) {
    super.setElement(element);

    this.onElementSelected(element);

    this.manageElement(element);
  }

  async manageElement(element) {
    Carto.dossierGeoref = null;

    // Chaque élément a un attribut data-carto-url contenant l'URL d'accès à son aperçu
    const cartoUrl = element.getAttribute('data-carto-url');
    try {
      const headers = new Headers({
        // Header custom pour indiquer qu'on ne souhaite pas récupérer une page complète
        'X-HTML-FRAGMENT': 'true',
      });
      const response = await fetch(cartoUrl, { headers });
      this.previewContainer.innerHTML = await response.text();

      if (!response.ok) {
        return;
      }

      this.init(element.getAttribute('data-dossier-id'));

      this.checkDetailsActions();
    } catch (error) {
      console.error(error);
      // TODO: Ajouter un message d'erreur côté UI ?
    }
  }

  checkDetailsActions() {
    super.checkDetailsActions();

    const openMapTab = this.previewContainer.querySelector(
      '.search-results-preview [data-action="search-result-details:open-carto-tab"]',
    );
    openMapTab.classList.add('active-tab');
    openMapTab.removeAttribute('disabled');

    const openPreviewTab = document.querySelector(
      '.search-results-preview [data-action="search-result-details:open-preview-tab"]',
    );
    openPreviewTab.removeAttribute('disabled');
  }

  initGeoref() {
    const jsonElement = document.querySelector('#dossier-georef-json');
    if (!jsonElement) {
      return;
    }

    Carto.dossierGeoref = JSON.parse(jsonElement.innerText);
  }
}
